import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";

export const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();
  const nextLanguage = language === "en" ? "Bulgarian" : "English";

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setLanguage(language === "en" ? "bg" : "en")}
      aria-label={`Switch language to ${nextLanguage}`}
      title={`Switch language to ${nextLanguage}`}
      className="text-xs font-medium text-muted-foreground hover:text-foreground transition-colors"
    >
      {language === "en" ? "БГ" : "EN"}
    </Button>
  );
};